import React, { useEffect, useState } from 'react'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import styles from './ProgressBar.module.css'
import cx from 'classnames'
import Icon from '../../../../components/Icon'
import { useIndividualizationContext } from '../../../../contexts/individualizationContext'

const ProgressBar: React.FC<{ clickable?: boolean }> = ({
    clickable = true,
}) => {
    const { changeActiveStep, steps, activeStep, completedSteps } =
        useIndividualizationContext()
    const [progress, setProgress] = useState<number>(0)

    useEffect(() => {
        setProgress((activeStep / (steps.length - 1)) * 100)
    }, [activeStep, steps])

    return (
        <div className={'zr-mb-6'}>
            <div className={cx(styles['zr-step-bar'])}>
                {steps.map((step, index) => {
                    return (
                        <div
                            onClick={() => {
                                if (clickable) changeActiveStep(index)
                            }}
                            className={cx(
                                styles['zr-step'],
                                activeStep === index
                                    ? styles['zr-step-active']
                                    : ''
                            )}
                            key={index}
                        >
                            {completedSteps.includes(steps.indexOf(step)) ? (
                                <Icon icon={faCheck} />
                            ) : (
                                index + 1
                            )}
                            <div className={cx(styles['zr-step-text'])}>
                                {step}
                            </div>
                        </div>
                    )
                })}
                <hr className={cx(styles['zr-stepper-line-grey'])} />
                <hr
                    className={cx(styles['zr-stepper-line-progress'])}
                    style={{ width: `calc(${progress}% - 4px)` }}
                />
            </div>
        </div>
    )
}

export default ProgressBar
